;
define("backbone_collection_view_row.tpl", function(){});

